import { ElementRef } from '@angular/core';
import { catchError, EMPTY, Subject, switchMap } from 'rxjs';
import scrollIntoView from 'scroll-into-view-if-needed';
import { ToastMessageType } from 'Angular/features/components/toast-messages/toast-messages.enum';
import { PageToastMessagesService } from 'Angular/features/components/toast-messages/page-toast-messages-service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { GlossaryService } from 'GlossaryApp/ts/services/glossary.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/urls.service";
import * as i2 from "GlossaryApp/ts/services/glossary.service";
import * as i3 from "Angular/features/components/toast-messages/page-toast-messages-service";
import * as i4 from "@angular/common";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i6 from "../../../../../../../../search/static/search/ts/features/icon-search-autocomplete/icon-search-autocomplete.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/components/toast-messages/page-toast-messages.component";
const _c0 = (a0, a1) => ({ "col-12": a0, "col-9": a1 });
const _c1 = a0 => ({ "active": a0 });
const _forTrack0 = ($index, $item) => $item.internalName;
function GlossaryIndexComponent_Conditional_14_For_4_Conditional_3_For_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li")(1, "a", 20);
    i0.ɵɵlistener("click", function GlossaryIndexComponent_Conditional_14_For_4_Conditional_3_For_2_Template_a_click_1_listener() { const subcategory_r5 = i0.ɵɵrestoreView(_r4).$implicit; const category_r2 = i0.ɵɵnextContext(2).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.filterByCategory(subcategory_r5.internalName, category_r2.internalName)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const subcategory_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c1, ctx_r2.selectedCategory === subcategory_r5.internalName));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", subcategory_r5.name, " ");
} }
function GlossaryIndexComponent_Conditional_14_For_4_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 21);
    i0.ɵɵrepeaterCreate(1, GlossaryIndexComponent_Conditional_14_For_4_Conditional_3_For_2_Template, 3, 4, "li", null, _forTrack0);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵrepeater(category_r2.subcategories);
} }
function GlossaryIndexComponent_Conditional_14_For_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 19)(1, "a", 20);
    i0.ɵɵlistener("click", function GlossaryIndexComponent_Conditional_14_For_4_Template_a_click_1_listener() { const category_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.filterByCategory(category_r2.internalName)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(3, GlossaryIndexComponent_Conditional_14_For_4_Conditional_3_Template, 3, 0, "ul", 21);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r2 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c1, ctx_r2.selectedCategory === category_r2.internalName || ctx_r2.selectedParentCategory === category_r2.internalName));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", category_r2.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(category_r2.subcategories ? 3 : -1);
} }
function GlossaryIndexComponent_Conditional_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 12)(1, "div", 17)(2, "ul", 18);
    i0.ɵɵrepeaterCreate(3, GlossaryIndexComponent_Conditional_14_For_4_Template, 4, 5, "li", 19, _forTrack0);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r2.categories);
} }
function GlossaryIndexComponent_For_19_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 24);
    i0.ɵɵlistener("click", function GlossaryIndexComponent_For_19_Conditional_0_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r6); const letter_r7 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.scrollToLetter(letter_r7)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const letter_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", letter_r7, " ");
} }
function GlossaryIndexComponent_For_19_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const letter_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", letter_r7, " ");
} }
function GlossaryIndexComponent_For_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, GlossaryIndexComponent_For_19_Conditional_0_Template, 2, 1, "a", 22)(1, GlossaryIndexComponent_For_19_Conditional_1_Template, 2, 1, "span", 23);
} if (rf & 2) {
    const letter_r7 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r2.letters.indexOf(letter_r7) > -1 ? 0 : 1);
} }
function GlossaryIndexComponent_For_21_For_6_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-video");
} }
function GlossaryIndexComponent_For_21_For_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 28)(1, "a", 29);
    i0.ɵɵlistener("click", function GlossaryIndexComponent_For_21_For_6_Template_a_click_1_listener() { const term_r9 = i0.ɵɵrestoreView(_r8).$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.navigateToDefinitionPage(term_r9.internalName)); });
    i0.ɵɵtext(2);
    i0.ɵɵconditionalCreate(3, GlossaryIndexComponent_For_21_For_6_Conditional_3_Template, 2, 1, "span", 30);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const term_r9 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", term_r9.name, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(term_r9.videoLink ? 3 : -1);
} }
function GlossaryIndexComponent_For_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 16)(1, "div", 25);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "hr", 26);
    i0.ɵɵelementStart(4, "ul", 27);
    i0.ɵɵrepeaterCreate(5, GlossaryIndexComponent_For_21_For_6_Template, 4, 2, "li", 28, _forTrack0);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const letter_r10 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", i0.ɵɵinterpolate1("section-", letter_r10));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(letter_r10);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r2.terms[letter_r10]);
} }
export class GlossaryIndexComponent {
    constructor(eltRef, urlsService, glossaryService, toastMessagesService) {
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.glossaryService = glossaryService;
        this.toastMessagesService = toastMessagesService;
        this.alphabet = ['#', ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i))];
        this.letters = [];
        this.terms = {};
        this.categories = [];
        this.selectedCategory = '';
        this.selectedParentCategory = null;
        this.filterSubject$ = new Subject();
        this.subscription = null;
        const categories = JSON.parse(this.eltRef.nativeElement.getAttribute('categories')) ?? [];
        if (categories.length > 0) {
            this.categories = [{ internalName: '', name: 'All', subcategories: [] }, ...categories];
        }
    }
    ngOnInit() {
        this.subscription = this.filterSubject$
            .pipe(switchMap((filters) => {
            return this.glossaryService.getGlossaryData(filters).pipe(catchError(() => {
                this.toastMessagesService.addMessage('Error fetching data', ToastMessageType.ERROR);
                return EMPTY;
            }));
        }))
            .subscribe((data) => {
            this.letters = data.letters;
            this.terms = data.terms;
        });
        this.filterSubject$.next({});
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe(); // eslint-disable-line no-unused-expressions
    }
    filterByCategory(category, parentCategory = null) {
        this.selectedCategory = category;
        this.selectedParentCategory = parentCategory;
        const filters = {};
        if (category !== '') {
            filters.category = category;
        }
        this.filterSubject$.next(filters);
    }
    navigateToDefinitionPage(term) {
        if (term !== undefined) {
            window.location.href = this.urlsService.getUrl(this.urlsService.GLOSSARY.GLOSSARY_TERM, { term });
        }
    }
    scrollToLetter(letter) {
        setTimeout(() => {
            const querySelector = `section-${letter}`;
            const target = document.getElementById(querySelector);
            if (target) {
                scrollIntoView(target, { behavior: 'smooth', block: 'start' });
            }
        }, 0);
    }
}
GlossaryIndexComponent.ɵfac = function GlossaryIndexComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || GlossaryIndexComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.GlossaryService), i0.ɵɵdirectiveInject(i3.PageToastMessagesService)); };
GlossaryIndexComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: GlossaryIndexComponent, selectors: [["ycn-glossary-index"]], standalone: false, decls: 22, vars: 8, consts: [[1, "page-header", "page-header-support"], [1, "container"], [1, "w-full", "max-width-lg", "ml-auto", "mr-auto"], [1, "row"], [1, "page-title", "col-auto"], [1, "page-name"], [1, "page-header-actions"], [1, "width-260"], [3, "submitHandler", "appendToBody", "placeholder", "searchType"], [1, "page-body", "container"], [1, "max-width-lg", "width-full", "ml-auto", "mr-auto"], [1, "row", "wide-gutters-lg"], [1, "col-3", "tabs", "tabs-vertical"], [1, "tab-content", 3, "ngClass"], [1, "tab-pane", "active", "pl-0", "pr-0"], [1, "d-flex", "align-items-center", "justify-evenly", "flex-wrap", "mb-4", 2, "justify-content", "space-evenly"], [1, "mb-5", 3, "id"], [1, "tabs", "tabs-vertical"], [1, "nav", "nav-sticky"], [1, "nav-item"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click", "ngClass"], [1, "list-unstyled", "ml-1", 2, "display", "block"], ["href", "javascript:void(0)", 1, "btn", "btn-link"], [1, "btn", "btn-link", "disabled", 2, "cursor", "default"], ["href", "javascript:void(0)", 1, "btn", "btn-link", 3, "click"], [1, "topic-title", "mb-2"], [1, "hr", "mb-3"], [1, "list-unstyled", "glossary-section-terms", 2, "list-style", "none", "padding-left", "0", "margin-left", "0", "column-count", "3", "column-gap", "2rem"], [1, "mb-1", "block"], ["href", "javascript:void(0)", 1, "text-link", 3, "click"], [1, "ml-1", "btn", "btn-circle", "btn-sm", "btn-transparent"], ["ycnIcon", "", 3, "name"]], template: function GlossaryIndexComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "ycn-page-toast-messages");
        i0.ɵɵelementStart(1, "div", 0)(2, "div", 1)(3, "div", 2)(4, "div", 3)(5, "div", 4)(6, "h1", 5);
        i0.ɵɵtext(7, "Financial Glossary");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(8, "div", 6)(9, "div", 7)(10, "ycn-icon-search-autocomplete", 8);
        i0.ɵɵlistener("submitHandler", function GlossaryIndexComponent_Template_ycn_icon_search_autocomplete_submitHandler_10_listener($event) { return ctx.navigateToDefinitionPage($event.search_id); });
        i0.ɵɵelementEnd()()()()()()();
        i0.ɵɵelementStart(11, "section", 9)(12, "div", 10)(13, "div", 11);
        i0.ɵɵconditionalCreate(14, GlossaryIndexComponent_Conditional_14_Template, 5, 0, "section", 12);
        i0.ɵɵelementStart(15, "section", 13)(16, "div", 14)(17, "div", 15);
        i0.ɵɵrepeaterCreate(18, GlossaryIndexComponent_For_19_Template, 2, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
        i0.ɵɵelementEnd();
        i0.ɵɵrepeaterCreate(20, GlossaryIndexComponent_For_21_Template, 7, 3, "section", 16, i0.ɵɵrepeaterTrackByIdentity);
        i0.ɵɵelementEnd()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("appendToBody", false)("placeholder", "Search Term")("searchType", "glossary_term");
        i0.ɵɵadvance(4);
        i0.ɵɵconditional(ctx.categories.length > 0 ? 14 : -1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c0, ctx.categories.length === 0, ctx.categories.length > 0));
        i0.ɵɵadvance(3);
        i0.ɵɵrepeater(ctx.alphabet);
        i0.ɵɵadvance(2);
        i0.ɵɵrepeater(ctx.letters);
    } }, dependencies: [i4.NgClass, i5.IconDirective, i6.IconSearchAutocompleteComponent, i7.PageToastMessagesComponent], encapsulation: 2 });
